import React, { useState, useEffect, useRef } from "react";
import swalMessage from "@sweetalert/with-react";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Button } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import CommonService from "../../../services/Common/CommonService";
import BarcodeReader from "react-barcode-reader";
import { DatePicker } from "@y0c/react-datepicker";
import { format } from "date-fns";
import * as XLSX from "xlsx";
import {
  inventoryHistoryActions,
  masterActions,
  productActions,
} from "../../../_store";
import { useSelector, useDispatch } from "react-redux";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import Select from "react-select";
import Toastr from "../../components/common/Toastr";
import {
  restApi,
  restApi_PD,
} from "../../../services/wooCommerceRestApi/restApi";
import emptyImage from "../../../images/no-image-png-2.png";

const BulkInventory = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector((x) => x.auth.user);
  const location = useLocation();
  const ProductID = location.state ? location.state.ProductID : 0;
  const ProductName = location.state ? location.state.ProductName : "";
  const rowRefs = useRef({});

  let styles = {
    control: (styles) => ({ ...styles, border: "1px solid red" }),
  };

  const refBarcodeVerifySKU = useRef("");
  const refreshIntervalRef = useRef(null);
  const latestRowsRef = useRef([]);

  const [loader, showLoader, hideLoader] = useFullPageLoader();

  // #region Reducers ------------------  Reducers --------------------------------

  //#region Popup
  const transactionTypeDrpList = useSelector(
    (x) => x.master.transactionTypeDrpList,
  );
  const vendorDrpList = useSelector((x) => x.master.vendorDrpList);
  const warehouseDrpList = useSelector((x) => x.master.warehouseDrpList);

  const productDetailDrpList = useSelector(
    (x) => x.master.productDetailDrpList,
  );

  const mrForDropdown = useSelector(
    (x) => x.inventoryHistory.merchandiseReceptionForDropdown,
  );
  const [merchandiseReceptionForDropdown, setMerchandiseReceptionForDropdown] =
    useState([{ value: 0, label: "New" }]);

  const categoryDrpList = useSelector((x) => x.master.categoryDrpList);
  const [BulkInventory, setBulkInventory] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const { REACT_APP_API_IMAGE_URL } = process.env;
  const [isEditMode, setIsEditMode] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  const [MerchandiseReceptionProduct, setMerchandiseReceptionProduct] =
    useState([]);

  //Add data

  const initialFormData = {
    ProductID: "",
    ProductName: "",
    CategoryID: 0,
    SubCategoryID: 0,
    ProductOption: null,
    ProductImage: "",
    TransactionTypeOption: { value: 0, label: "Select..." },
    CategoryOption: null,
    SubCategoryOption: null,
    TransactionTypeID: 0,
    FromWareHouseID: 0,
    FromWarehouseOption: null,
    ToWareHouseID: 0,
    ToWarehouseOption: null,
    VendorID: 0,
    InvoiceNumber: "",
    VendorOption: null,
    ActualInventory: 0,
    TransactionUnits: "",
    FinalInventory: 0,
    Status: 1,
    CreatedBy: currentUser.Id,
    Location: "",
    LotNumber: "",
    LotDate: new Date().toISOString(),
    IsGemar: false,
    IsPartyDeco: false,
    WCProductID: 0,
    PDWCProductID: 0,
    PurchaseType: 1,
    PurchaseTypeOption: { value: 1, label: "Direct Inventory" },
    ExistingPurchaseOrderOption: { value: 0, label: "New" },
  };
  const [addFormData, setAddFormData] = useState(initialFormData);

  const PurchaseTypeOption = [
    { value: 1, label: "Direct Inventory" },
    { value: 2, label: "Merchandise Reception" },
  ];

  const newFormData = { ...addFormData };

  useEffect(() => {
    if (mrForDropdown && mrForDropdown.length > 0) {
      setMerchandiseReceptionForDropdown([
        { value: 0, label: "New" },
        ...mrForDropdown.filter((x) => x.value !== 0),
      ]);
    }
  }, [mrForDropdown]);

  useEffect(() => {
    let Status = 1;
    let ProductID = 0;
    dispatch(masterActions.GetOrderProductDrpList({ ProductID, Status }));
    // let MerchandiseReceptionID = 0;
    // let IsCompleted = false;
    // dispatch(
    //   inventoryHistoryActions.GetMerchandiseReceptionForDropdown({
    //     MerchandiseReceptionID,
    //     IsCompleted,
    //     Status,
    //   })
    // );
  }, [dispatch]);

  useEffect(() => {
    if (newFormData?.TransactionTypeOption?.value === 1) {
      let Status = 1;
      let MerchandiseReceptionID = 0;
      let IsCompleted = false;
      dispatch(
        inventoryHistoryActions.GetMerchandiseReceptionForDropdown({
          MerchandiseReceptionID,
          IsCompleted,
          Status,
        }),
      );
    }
  }, [newFormData?.TransactionTypeOption]);

  useEffect(() => {
    latestRowsRef.current = MerchandiseReceptionProduct;
  }, [MerchandiseReceptionProduct]);

  // handle Dropdown Change function
  const handleDrpChange = async (event, title) => {
    const updatedFormData = { ...newFormData };
    updatedFormData[title] = event.value ? parseInt(event.value) : null;

    if (title === "ProductID") {
      const ProductID = parseInt(event.value);
      updatedFormData.ProductOption = {
        value: ProductID,
        label: event.label,
      };

      dispatch(productActions.GetProductDetailsByID({ ProductID })).then(
        (response) => {
          if (response?.type === "product/GetProductDetailsByID/fulfilled") {
            if (response?.payload) {
              let getInventoryDetailList = response?.payload;

              if (getInventoryDetailList) {
                updatedFormData.CategoryOption = {
                  value: getInventoryDetailList.CategoryID,
                  label: getInventoryDetailList.CategoryName,
                };
                updatedFormData.SubCategoryOption = {
                  value: getInventoryDetailList.SubCategoryID,
                  label: getInventoryDetailList.SubCategoryName,
                };

                //Update FinalInventory
                updatedFormData.FinalInventory = 0;

                const ProductImage =
                  getInventoryDetailList?.ProductImageModelList?.[0]
                    ?.ImageFilePath || "";

                updatedFormData.ProductImage = ProductImage;
                updatedFormData.TransactionUnits = 0;
                updatedFormData.ActualInventory =
                  getInventoryDetailList.StockQuantity;

                updatedFormData.WCProductID =
                  getInventoryDetailList.WCProductID;
                updatedFormData.PDWCProductID =
                  getInventoryDetailList.PDWCProductID;
                updatedFormData.IsGemar = getInventoryDetailList.IsGemar;
                updatedFormData.IsPartyDeco =
                  getInventoryDetailList.IsPartyDeco;
              }
              setAddFormData(updatedFormData);
            }
          }
        },
      );
    } else if (title === "TransactionTypeID") {
      stopRefresh();
      updatedFormData.TransactionTypeOption = {
        value: parseInt(event.value),
        label: event.label,
      };
      updatedFormData.PurchaseTypeOption = {
        value: 1,
        label: "Direct Inventory",
      };

      updatedFormData.TransactionUnits = "";
      updatedFormData.FinalInventory = 0;
      updatedFormData.FromWareHouseID = 0;
      updatedFormData.FromWarehouseOption = null;

      if (parseInt(event.value) === 1) {
        updatedFormData.LotNumber = newFormData.LotNumber;
      } else {
        updatedFormData.LotNumber = "";
      }
    } else if (title === "FromWareHouseID") {
      updatedFormData.FromWarehouseOption = {
        value: parseInt(event.value),
        label: event.label,
      };
    } else if (title === "ToWareHouseID") {
      updatedFormData.ToWarehouseOption = {
        value: parseInt(event.value),
        label: event.label,
      };
    } else if (title === "VendorID") {
      updatedFormData.VendorOption = {
        value: parseInt(event.value),
        label: event.label,
      };
    } else if (title === "PurchaseType") {
      stopRefresh();
      updatedFormData.PurchaseTypeOption = {
        value: parseInt(event.value),
        label: event.label,
      };

      updatedFormData.ExistingPurchaseOrderOption = {
        value: 0,
        label: "New",
      };
    } else if (title === "ExistingPurchaseOrderID") {
      updatedFormData.ExistingPurchaseOrderOption = {
        value: parseInt(event.value),
        label: event.label,
      };
    }

    // Update the form data state
    if (title !== "ProductID") {
      setAddFormData(updatedFormData);
    }
  };

  //Add contact function
  const handleChange = (event) => {
    event.preventDefault();
    const regexString = /^[a-zA-Z\s]*$/;
    const regexNumber = /^[0-9\b]+$/;

    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;
    //const newFormData = { ...addFormData };
    if (fieldValue && fieldValue.trim()) {
      if (fieldName === "TransactionUnits") {
        if (fieldValue === "" || regexNumber.test(fieldValue)) {
          const transactionUnits = Number(fieldValue);
          if (transactionUnits === 0 && fieldValue !== "") {
            Toastr("Transaction Units cannot be zero", "warning");
            newFormData.TransactionUnits = 0;
            newFormData.FinalInventory = 0;
          } else if (
            fieldValue &&
            (newFormData.TransactionTypeOption.label === "Adjustment Credit" ||
              newFormData.TransactionTypeOption.label === "Purchase")
          ) {
            newFormData.FinalInventory =
              Number(newFormData.ActualInventory) + Number(fieldValue);
          } else if (
            fieldName === "TransactionUnits" &&
            fieldValue &&
            newFormData.TransactionTypeOption.label === "Adjustment Debit"
          ) {
            if (newFormData.ActualInventory < Number(fieldValue)) {
              newFormData.TransactionUnits = 0;
              newFormData.FinalInventory = 0;
              Toastr(
                "Transaction Units cannot greater than Actual Inventory",
                "warning",
              );
            } else {
              newFormData.FinalInventory =
                Number(newFormData.ActualInventory) - Number(fieldValue);
            }
          } else if (fieldName === "TransactionUnits" && !fieldValue) {
            newFormData.FinalInventory = 0;
          }

          newFormData[fieldName] = fieldValue;
        }
      } else if (fieldName === "LotNumber") {
        newFormData[fieldName] = fieldValue.trim();
      } else {
        newFormData[fieldName] = fieldValue;
      }
    } else {
      newFormData[fieldName] = fieldValue.trim();
    }

    setAddFormData(newFormData);
  };

  // Function for Date
  const handleDateChange = (date) => {
    setAddFormData((prev) => ({
      ...prev,
      LotDate: date ? date.$d : null, // keep Date object, not ISO string
    }));
  };

  // Function to delete an inventory item
  const handleDeleteInventory = (index) => {
    let updatedList = [...BulkInventory];
    updatedList.splice(index, 1); // Remove item from array
    setBulkInventory(updatedList);

    if (isEditMode && editIndex === index) {
      setIsEditMode(false);
      setAddFormData({
        ProductOption: "",
        CategoryOption: "",
        SubCategoryOption: "",
        TransactionTypeID: 0,
        FromWareHouseID: 0,
        ToWareHouseID: 0,
        VendorOption: "",
        InvoiceNumber: "",
        TransactionUnits: "",
        ActualInventory: "",
        FinalInventory: "",
        LotNumber: "",
        LotDate: "",
        ProductImage: "",
        WCProductID: 0,
        PDWCProductID: 0,
        IsGemar: false,
        IsPartyDeco: false,
      });
    }
  };

  //handle Add Inventory
  const handleAddInventory = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    if (
      !newFormData.ProductOption ||
      !newFormData.TransactionTypeID ||
      (newFormData.TransactionTypeID && newFormData.TransactionTypeID < 1) ||
      !newFormData.FromWareHouseID ||
      (newFormData.FromWareHouseID && newFormData.FromWareHouseID < 1) ||
      !newFormData.InvoiceNumber ||
      !newFormData.TransactionUnits ||
      (newFormData.TransactionUnits && newFormData.TransactionUnits < 1) ||
      (newFormData.TransactionTypeID === 1 && !newFormData.LotNumber) || // Check for LotNumber when TransactionTypeID is 1
      (newFormData.TransactionTypeID === 1 && !newFormData.LotDate)
    ) {
      Toastr("Please fill in all required fields.", "warning");
      return;
    }

    if (newFormData.TransactionTypeOption?.label === "Adjustment Debit") {
      if (newFormData.ActualInventory < Number(newFormData.TransactionUnits)) {
        newFormData.TransactionUnits = 0;
        newFormData.FinalInventory = 0;
        Toastr(
          "Transaction Units cannot greater than Actual Inventory",
          "warning",
        );
        setAddFormData(newFormData);
        return;
      }
    }

    if (
      newFormData.ProductOption &&
      newFormData.TransactionTypeID &&
      newFormData.FromWareHouseID &&
      newFormData.InvoiceNumber &&
      newFormData.TransactionUnits &&
      newFormData.TransactionUnits > 0
    ) {
      const isProductExists = BulkInventory.some((item, index) => {
        if (isEditMode && index === editIndex) {
          return false;
        }
        return item.ProductOption.value === newFormData.ProductOption.value; // Check if product exists
      });

      if (isProductExists) {
        Toastr("Product already exists in the inventory", "warning");
        return;
      }
      let responseStatus = 0;
      // Validate Lot Number only if TransactionTypeID is 1
      if (newFormData.TransactionTypeID === 1 && newFormData.LotNumber) {
        const params = {
          LotNumber: newFormData.LotNumber,
          ProductID: newFormData.ProductOption?.value,
        };

        try {
          console.log("Checking Lot Number Exist:", params);
          const res = await CommonService.LotNumberExistCheck(params);

          console.log("API Response:", res);

          if (res?.data === 1) {
            responseStatus = 1;
          } else {
            Toastr(
              "This Lot Number has already been created. Please enter another Lot Number.",
              "warning",
            );
            return;
          }
        } catch (error) {
          console.error("Error checking Lot Number:", error);
          Toastr("Error checking Lot Number. Please try again.", "error");
          return;
        }
      } else {
        responseStatus = 1;
      }

      if (responseStatus === 1) {
        if (isEditMode) {
          // Update existing inventory item
          const updatedInventory = BulkInventory.map((item, index) =>
            index === editIndex ? { ...newFormData } : item,
          );
          setBulkInventory(updatedInventory);
          setIsEditMode(false);
        } else {
          // Add new product to inventory
          setBulkInventory([...BulkInventory, { ...newFormData }]);
        }

        // Clear form after submitting
        setAddFormData({
          ProductOption: "",
          CategoryOption: "",
          SubCategoryOption: "",
          TransactionTypeID: 0,
          TransactionTypeOption: { value: 0, label: "Select..." },
          FromWareHouseID: 0,
          ToWareHouseID: 0,
          VendorOption: "",
          InvoiceNumber: "",
          TransactionUnits: 0,
          ActualInventory: 0,
          StockQuantity: 0,
          FinalInventory: 0,
          LotNumber: "",
          LotDate: new Date(),
          ProductImage: "",
          WCProductID: 0,
          PDWCProductID: 0,
          IsGemar: false,
          IsPartyDeco: false,
        });

        setSubmitted(false);
      }
    }
  };

  // Submit data function
  const handleSubmit = async (event, title) => {
    showLoader();
    if (BulkInventory.length > 0) {
      let gemar_data = [];
      let PD_data = [];
      let iserror = false;

      let transactionHistoryList = BulkInventory.map((model, index) => {
        let FinalInventory =
          model.TransactionTypeID === 4
            ? parseInt(model.ActualInventory) - parseInt(model.TransactionUnits)
            : parseInt(model.ActualInventory) +
              parseInt(model.TransactionUnits);

        // Check for sufficient stock for transaction
        if (FinalInventory < 0) {
          iserror = true;
          model.Status = 0;
        } else {
          model.Status = 1;
        }
        // Set LotDate based on TransactionTypeID
        model.LotDate =
          model.TransactionTypeID === 3 || model.TransactionTypeID === 4
            ? model.LotDate
              ? new Date(model.LotDate).toISOString()
              : new Date().toISOString()
            : model.LotDate
              ? new Date(model.LotDate).toISOString()
              : new Date().toISOString(); // never null

        // Push updated stock quantity into respective lists
        if (model.IsGemar) {
          gemar_data.push({
            id: Number(model.WCProductID) || 0,
            stock_quantity: FinalInventory,
          });
        }

        if (model.IsPartyDeco) {
          PD_data.push({
            id: Number(model.PDWCProductID) || 0,
            stock_quantity: FinalInventory,
          });
        }

        return {
          ProductID: model.ProductID ?? 0,
          TransactionTypeID: model.TransactionTypeID ?? 0,
          VendorID: model.VendorID ?? 0,
          InvoiceNumber: model.InvoiceNumber || "",
          ActualInventory: model.ActualInventory ?? 0,
          TransactionUnits: parseInt(model.TransactionUnits) || 0,
          FinalInventory: FinalInventory,
          FromWareHouseID: model.FromWareHouseID ?? 0,
          ToWareHouseID: model.ToWareHouseID ?? 0,
          Status: model.Status ?? 0,
          LotNumber: model.LotNumber || "",
          LotDate: model.LotDate,
        };
      });

      // Error handling for insufficient stock
      if (iserror && title) {
        hideLoader();
        Toastr("Insufficient product quantity. Kindly modify.", "warning");
        return;
      }

      if (gemar_data.length > 0 && PD_data.length > 0) {
        AddUpdateOrder_GemarAndPD(gemar_data, PD_data, transactionHistoryList);
      } else if (gemar_data.length > 0) {
        AddUpdateOrder_Gemar(gemar_data, transactionHistoryList);
      } else if (PD_data.length > 0) {
        AddUpdateOrder_PD(PD_data, transactionHistoryList);
      }
    } else {
      hideLoader();
      Toastr("Please Add Atleast One Product", "warning");
    }
  };

  function AddUpdateOrder_GemarAndPD(gemar_data, PD_data, data) {
    const batchSize = 200; // Define the batch size
    let gemarPage = 0;
    let PDPage = 0;
    let totalGemarPages = Math.ceil(gemar_data.length / batchSize);
    let totalPDPages = Math.ceil(PD_data.length / batchSize);

    // Function to update a batch for Gemar API
    const updateGemarBatch = (batchData, page) => {
      let gemarData = {
        update: batchData,
      };

      restApi
        .post("products/batch", gemarData) // Gemar API
        .then((response) => {
          if (
            response.status === 200 ||
            response.status === 201 ||
            !response.statusText
          ) {
            if (page < totalGemarPages - 1) {
              // Move to the next Gemar batch
              gemarPage++;
              sendNextGemarBatch(gemarPage);
            } else {
              // Once Gemar batches are done, proceed to Party Deco API
              sendNextPDBatch(PDPage);
            }
          } else {
            hideLoader();
            if (newFormData.PurchaseTypeOption?.value === 2) {
              UnlockMerchandiseReception(data.MerchandiseReceptionID);
            }
            Toastr(response.statusText, "warning");
          }
        })
        .catch((error) => {
          hideLoader();
          if (newFormData.PurchaseTypeOption?.value === 2) {
            UnlockMerchandiseReception(data.MerchandiseReceptionID);
          }
          let msg = error.response
            ? error.response.data.message
            : "rest Api error";
          Toastr(msg, "warning");
        });
    };

    // Function to update a batch for Party Deco API
    const updatePDBatch = (batchData, page) => {
      let PDData = {
        update: batchData,
      };

      restApi_PD
        .put("products/batch", PDData) // Party Deco API
        .then((PDResponse) => {
          if (
            PDResponse.status === 200 ||
            PDResponse.status === 201 ||
            !PDResponse.statusText
          ) {
            if (page < totalPDPages - 1) {
              // Move to the next Party Deco batch
              PDPage++;
              sendNextPDBatch(PDPage);
            } else {
              if (newFormData.PurchaseTypeOption?.value === 2) {
                // Update Inventory Payload for Merchandise Reception as Completed
                bulkInventoryMRPayload(data);
              } else {
                // bulk Inventory Payload
                const payload = {
                  TypeTransactionHistoryModel: data,
                  CreatedBy: currentUser.Id,
                  IsSucced: 1,
                };
                bulkInventoryPayload(payload);
              }
            }
          } else {
            if (newFormData.PurchaseTypeOption?.value === 2) {
              UnlockMerchandiseReception(data.MerchandiseReceptionID);
            }
            hideLoader();
            Toastr(PDResponse.statusText, "warning");
          }
        })
        .catch((error) => {
          if (newFormData.PurchaseTypeOption?.value === 2) {
            UnlockMerchandiseReception(data.MerchandiseReceptionID);
          }

          hideLoader();
          let msg = error.response
            ? error.response.data.message
            : "rest Api error";
          Toastr(msg, "warning");
        });
    };

    // Function to send the next batch of Gemar data
    const sendNextGemarBatch = (page) => {
      let start = page * batchSize;
      let end = start + batchSize;
      let batchData = gemar_data.slice(start, end); // Get the next Gemar batch

      if (batchData.length > 0) {
        updateGemarBatch(batchData, page);
      }
    };

    // Function to send the next batch of Party Deco data
    const sendNextPDBatch = (page) => {
      let start = page * batchSize;
      let end = start + batchSize;
      let batchData = PD_data.slice(start, end); // Get the next Party Deco batch

      if (batchData.length > 0) {
        updatePDBatch(batchData, page);
      }
    };

    // Start by sending the first batch for Gemar API
    if (gemar_data.length > 0) {
      showLoader(); // Display loader while processing
      sendNextGemarBatch(gemarPage); // Start with Gemar API
    } else if (PD_data.length > 0) {
      // If no Gemar data but Party Deco data exists, process Party Deco directly
      sendNextPDBatch(PDPage);
    } else {
      hideLoader();
      Toastr("No data to update", "warning");
    }
  }

  function AddUpdateOrder_Gemar(gemar_data, data) {
    // Maximum items per batch (pagination)
    const batchSize = 200;
    let page = 0; // Track the current page
    let totalPages = Math.ceil(gemar_data.length / batchSize); // Calculate total pages

    // Function to update the order for each batch
    const updateBatch = (batchData, page) => {
      let gemarData = {
        update: batchData,
      };

      // Send the API request for the current batch
      restApi
        .post("products/batch", gemarData) // Gemar API
        .then((response) => {
          if (
            response.status === 200 ||
            response.status === 201 ||
            !response.statusText
          ) {
            if (page < totalPages - 1) {
              // Move to the next page/batch
              page++;
              sendNextBatch(page);
            } else {
              if (newFormData.PurchaseTypeOption?.value === 2) {
                // Update Inventory Payload for Merchandise Reception as Completed
                bulkInventoryMRPayload(data);
              } else {
                // bulk Inventory Payload
                const payload = {
                  TypeTransactionHistoryModel: data,
                  CreatedBy: currentUser.Id,
                  IsSucced: 1,
                };
                bulkInventoryPayload(payload);
              }
            }
          } else {
            if (newFormData.PurchaseTypeOption?.value === 2) {
              UnlockMerchandiseReception(data.MerchandiseReceptionID);
            }
            hideLoader();
            Toastr(response.statusText, "warning");
          }
        })
        .catch((error) => {
          hideLoader();
          if (newFormData.PurchaseTypeOption?.value === 2) {
            UnlockMerchandiseReception(data.MerchandiseReceptionID);
          }
          let msg = "";
          if (error.response) {
            msg = error.response.data.message;
          } else {
            msg = "rest Api error";
          }
          Toastr(msg, "warning");
        });
    };

    // Function to send the next batch of data
    const sendNextBatch = (page) => {
      let start = page * batchSize;
      let end = start + batchSize;
      let batchData = gemar_data.slice(start, end); // Get the next batch of data

      // Send batch to the API
      updateBatch(batchData, page);
    };

    // Start by sending the first batch
    if (gemar_data.length > 0) {
      showLoader(); // Display loader while processing
      sendNextBatch(page); // Start with the first page
    } else {
      Toastr("No data to update", "warning");
    }
  }

  function AddUpdateOrder_PD(PD_data, data) {
    // Maximum items per batch (pagination)
    const batchSize = 200;
    let page = 0; // Track the current page
    let totalPages = Math.ceil(PD_data.length / batchSize); // Calculate total pages

    // Function to update the order for each batch
    const updateBatch = (batchData, page) => {
      let PDData = {
        update: batchData,
      };

      // Send the API request for the current batch
      restApi_PD
        .put("products/batch", PDData) // Party Deco API
        .then((PDResponse) => {
          if (
            PDResponse.status === 200 ||
            PDResponse.status === 201 ||
            !PDResponse.statusText
          ) {
            if (page < totalPages - 1) {
              // Move to the next page/batch
              page++;
              sendNextBatch(page);
            } else {
              if (newFormData.PurchaseTypeOption?.value === 2) {
                // Update Inventory Payload for Merchandise Reception as Completed
                bulkInventoryMRPayload(data);
              } else {
                // bulk Inventory Payload
                const payload = {
                  TypeTransactionHistoryModel: data,
                  CreatedBy: currentUser.Id,
                  IsSucced: 1,
                };
                bulkInventoryPayload(payload);
              }
            }
          } else {
            hideLoader();
            if (newFormData.PurchaseTypeOption?.value === 2) {
              UnlockMerchandiseReception(data.MerchandiseReceptionID);
            }
            Toastr(PDResponse.statusText, "warning");
          }
        })
        .catch((error) => {
          hideLoader();
          if (newFormData.PurchaseTypeOption?.value === 2) {
            UnlockMerchandiseReception(data.MerchandiseReceptionID);
          }
          let msg = "";
          if (error.response) {
            msg = error.response.data.message;
          } else {
            msg = "rest Api error";
          }
          Toastr(msg, "warning");
        });
    };

    // Function to send the next batch of data
    const sendNextBatch = (page) => {
      let start = page * batchSize;
      let end = start + batchSize;
      let batchData = PD_data.slice(start, end); // Get the next batch of data

      // Send batch to the API
      updateBatch(batchData, page);
    };

    // Start by sending the first batch
    if (PD_data.length > 0) {
      showLoader(); // Display loader while processing
      sendNextBatch(page); // Start with the first page
    } else {
      Toastr("No data to update", "warning");
    }
  }

  function bulkInventoryPayload(data) {
    dispatch(inventoryHistoryActions.bulkInsertInventory(data)).then(
      (response) => {
        if (
          response?.type === "inventoryHistory/bulkInsertInventory/fulfilled"
        ) {
          if (response?.payload === 1) {
            Toastr("Inventory updated successfully", "success");
            hideLoader();
            setBulkInventory([]);
            setSubmitted(false);
            setAddFormData(initialFormData);
          } else {
            Toastr("error", "warning");
            hideLoader();
            setBulkInventory([]);
          }
        } else {
          Toastr("error", "warning");
          hideLoader();
          setBulkInventory([]);
        }
      },
    );
  }
  //handle Edit Inventory
  const handleEditInventory = (index) => {
    const value = { ...BulkInventory[index] };

    // ✅ Force consistent type: always Date or null
    if (value.LotDate) {
      // handle both string or Date
      value.LotDate = new Date(value.LotDate);
    } else {
      value.LotDate = null;
    }

    console.log("Editing LotDate:", value.LotDate, typeof value.LotDate);

    setAddFormData(value);
    setIsEditMode(true);
    setEditIndex(index);
  };

  const [submitted, setSubmitted] = useState(false);
  const [productList, setProductList] = useState([]);

  useEffect(() => {
    setProductList(productDetailDrpList);
  }, [productDetailDrpList]);

  useEffect(() => {
    if (ProductID && ProductID > 0) {
      newFormData.ProductID = ProductID;
      newFormData.ProductName = ProductName;
      newFormData.Location = Location;
      setAddFormData(newFormData);
      dispatch(
        inventoryHistoryActions.getInventoryHistoryListByID({ ProductID }),
      );
    }
    let TransactionTypeID = 0;
    let Status = 1;
    dispatch(
      masterActions.GetTransactionTypeDrpList({ TransactionTypeID, Status }),
    );
    let VendorID = 0;
    dispatch(masterActions.GetvendorDrpList({ VendorID, Status }));
    let WareHouseID = 0;
    dispatch(masterActions.GetWarehouseList({ WareHouseID, Status }));
  }, [dispatch]);

  //#region Merchandise Reception ------------------  Merchandise Reception --------------------------------

  useEffect(() => {
    // STOP old interval if exists
    if (refreshIntervalRef.current) {
      clearInterval(refreshIntervalRef.current);
      refreshIntervalRef.current = null;
    }

    if (!newFormData?.ExistingPurchaseOrderOption?.value) {
      setMerchandiseReceptionProduct([]);

      // if (newFormData?.ExistingPurchaseOrderOption?.value === 0) {
      //   newFormData.InvoiceNumber = "";
      //   newFormData.VendorID = 0;
      //   newFormData.FromWareHouseID = 0;
      //   newFormData.VendorOption = null;
      //   newFormData.FromWarehouseOption = null;
      // }

      //setAddFormData({ ...newFormData });
      return;
    }

    const MerchandiseReceptionID =
      newFormData.ExistingPurchaseOrderOption.value;

    const Status = 1;
    const CurrentUserID = currentUser?.Id;

    async function fetchLatestData() {
      try {
        const response = await dispatch(
          inventoryHistoryActions.GetMerchandiseReceptionProductByMRID({
            MerchandiseReceptionID,
            Status,
            CurrentUserID,
          }),
        );

        if (
          response?.type !==
          "inventoryHistory/GetMerchandiseReceptionProductByMRID/fulfilled"
        ) {
          return;
        }

        if (
          response?.payload?.merchandiseReceptionModel?.IsCompleted === true ||
          response?.payload?.merchandiseReceptionModel?.IsLocked === true
        ) {
          Toastr("This Merchandise Reception is already completed.", "warning");
          setMerchandiseReceptionProduct([]);
          setAddFormData(initialFormData);
          setSubmitted(false);
          setIsEditMode(false);
          setEditIndex(null);
          stopRefresh();
          return;
        }

        const dbRows =
          response?.payload?.merchandiseReceptionProductModel || [];

        let updatedRows = [];

        for (let row of dbRows) {
          // 🔥 use ref instead of using outdated React state
          const existingRow = latestRowsRef.current.find(
            (r) =>
              r.MerchandiseReceptionProductID ===
              row.MerchandiseReceptionProductID,
          );

          const isLockedByCurrentUser =
            row.IsLocked === true && row.LockedBy === currentUser?.Id;

          let updatedRow;

          if (isLockedByCurrentUser && existingRow) {
            updatedRow = {
              ...existingRow,
              StockQuantity: row.StockQuantity,
              OrderProcessedUnits: row.OrderProcessedUnits,
              IsLocked: row.IsLocked,
              LockedBy: row.LockedBy,
              LockedAt: row.LockedAt,
              IsSaved: row.IsSaved,
              Location: row.Location,
            };
          } else {
            updatedRow = { ...row };
          }

          updatedRows.push(updatedRow);
        }

        // update state
        setMerchandiseReceptionProduct(updatedRows);

        // Update form header
        newFormData.InvoiceNumber =
          response?.payload?.merchandiseReceptionModel?.InvoiceNumber || "";
        newFormData.VendorID =
          response?.payload?.merchandiseReceptionModel?.VendorID || 0;
        newFormData.FromWareHouseID =
          response?.payload?.merchandiseReceptionModel?.WareHouseID || 0;

        newFormData.VendorOption = vendorDrpList.filter(
          (d) =>
            d.value === response?.payload?.merchandiseReceptionModel?.VendorID,
        );
        newFormData.FromWarehouseOption = warehouseDrpList.filter(
          (d) =>
            d.value ===
            response?.payload?.merchandiseReceptionModel?.WareHouseID,
        );
        setAddFormData({ ...newFormData });

        // 🔥 keep latest values in ref to prevent clearing inputs
        latestRowsRef.current = updatedRows;
      } catch (err) {
        setMerchandiseReceptionProduct([]);
        console.error(err);
      }
    }

    fetchLatestData();

    // START NEW INTERVAL
    refreshIntervalRef.current = setInterval(() => {
      fetchLatestData();
    }, 5000);

    return () => {
      if (refreshIntervalRef.current) {
        clearInterval(refreshIntervalRef.current);
        refreshIntervalRef.current = null;
      }
    };
  }, [newFormData.ExistingPurchaseOrderOption]);

  const stopRefresh = () => {
    if (refreshIntervalRef.current) {
      clearInterval(refreshIntervalRef.current);
      refreshIntervalRef.current = null;
    }
  };

  const UploadExcelFile = async (event) => {
    if (
      !newFormData.FromWareHouseID ||
      (newFormData.FromWareHouseID && newFormData.FromWareHouseID < 1) ||
      !newFormData.VendorID ||
      (newFormData.VendorID && newFormData.VendorID < 1) ||
      !newFormData.InvoiceNumber
    ) {
      setSubmitted(true);
      Toastr("Please fill in all required fields.", "warning");
      event.target.value = "";
      return;
    }
    const file = event.target.files[0];

    if (!file) {
      Toastr("Please select an Excel file before uploading.", "warning");
      event.target.value = "";
      return;
    }

    const validExtensions = ["xlsx", "xls"];
    const fileExtension = file.name.split(".").pop().toLowerCase();

    if (!validExtensions.includes(fileExtension)) {
      Toastr(
        "Invalid file type. Please upload an Excel (.xlsx or .xls) file.",
        "warning",
      );
      event.target.value = "";
      return;
    }

    showLoader();
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

      if (jsonData.length === 0) {
        hideLoader();
        Toastr("The selected Excel file is empty.", "warning");
        event.target.value = "";
        return;
      }

      // ✅ Normalize headers: lowercase + trimmed keys
      const normalizedData = jsonData.map((row) => {
        const newRow = {};
        Object.keys(row).forEach((key) => {
          const cleanKey = key.toLowerCase().trim();
          newRow[cleanKey] = row[key];
        });
        return newRow;
      });

      // ✅ Define required columns (lowercase + trimmed)
      const requiredColumns = ["product sku", "transaction units"];
      const missingColumns = requiredColumns.filter(
        (col) => !(col in normalizedData[0]),
      );
      if (missingColumns.length > 0) {
        hideLoader();
        Toastr(
          `Missing required columns: ${missingColumns.join(", ")}`,
          "warning",
        );
        event.target.value = "";
        return;
      }

      // 🔥 Validate rows
      const invalidRows = normalizedData.filter((row, index) => {
        const sku = String(row["product sku"]).trim();
        const tUnits = row["transaction units"];

        // ❌ Missing SKU
        if (!sku) return true;

        // ❌ Missing Transaction Units
        if (tUnits === "" || tUnits === null || tUnits === undefined)
          return true;

        // ❌ Non-numeric OR contains alphabets or symbols (e.g., fsf2!#!)
        if (!/^\d+$/.test(String(tUnits).trim())) return true;

        // Convert to number now safe
        const tUnitsNum = Number(tUnits);

        // ❌ Zero or less
        if (tUnitsNum <= 0) return true;

        return false;
      });

      if (invalidRows.length > 0) {
        hideLoader();
        Toastr(
          "Invalid rows found. Check Product SKU and Transaction Units (must be positive number only).",
          "warning",
        );
        event.target.value = "";
        return;
      }

      // ✅ Extract SKUs
      // Extract SKUs (case insensitive)
      const excelSKUs = normalizedData.map((row) =>
        String(row["product sku"]).trim().toLowerCase(),
      );

      // ❌ CHECK FOR DUPLICATES IN EXCEL
      const skuCount = {};
      excelSKUs.forEach((sku) => {
        skuCount[sku] = (skuCount[sku] || 0) + 1;
      });

      const duplicateSKUs = Object.keys(skuCount).filter(
        (sku) => skuCount[sku] > 1,
      );

      if (duplicateSKUs.length > 0) {
        hideLoader();
        Toastr(
          `Duplicate SKUs found in Excel: ${duplicateSKUs.join(", ")}`,
          "warning",
        );
        event.target.value = "";
        return;
      }

      // Compare with model list (case-insensitive)
      const modelSKUs = productList.map((m) =>
        String(m.SKU).trim().toLowerCase(),
      );

      const missingInModel = excelSKUs.filter(
        (sku) => !modelSKUs.includes(sku),
      );

      if (missingInModel.length > 0) {
        hideLoader();
        Toastr(
          `These SKUs not found in model List  (  ${missingInModel.join(
            ", ",
          )} )`,
          "warning",
        );
        event.target.value = "";
      } else {
        const formData = new FormData();
        formData.append("file", file);
        formData.append(
          "metadata",
          JSON.stringify({
            UserID: currentUser?.Id,
            WareHouseID: newFormData.FromWareHouseID,
            TransactionTypeID: newFormData.TransactionTypeID,
            VendorID: newFormData.VendorID,
            InvoiceNumber: newFormData.InvoiceNumber,
          }),
        );

        dispatch(
          inventoryHistoryActions.addMerchandiseReception(formData),
        ).then((response) => {
          if (
            response?.type ===
            "inventoryHistory/addMerchandiseReception/fulfilled"
          ) {
            setMerchandiseReceptionProduct(
              response?.payload?.merchandiseReceptionProducts,
            );

            const newOption = {
              value: parseInt(
                response?.payload?.MerchandiseReception?.MerchandiseReceptionID,
              ),
              label:
                response?.payload?.MerchandiseReception?.PurchaseOrderNumber,
            };

            setMerchandiseReceptionForDropdown((prev) => {
              const exists = prev.some((opt) => opt.value === newOption.value);
              return exists ? prev : [...prev, newOption];
            });

            // ✅ Also set selected option in form
            setAddFormData((prev) => ({
              ...prev,
              ExistingPurchaseOrderOption: newOption,
            }));

            hideLoader();

            Toastr("Excel uploaded successfully!", "success");
          } else {
            hideLoader();
            Toastr("Error uploading Excel file.", "warning");
          }
        });

        // Toastr("All Excel SKUs matched successfully!", "warning");
      }
    };

    reader.readAsArrayBuffer(file);
  };

  const handleError = (err) => {
    Toastr(err, "warning");
    // console.error(err);
  };

  const handleScan = (data) => {
    if (!data) return; // 🔹 Ignore empty scans
    if (data.length < 3) return; // 🔹 Ignore too short scans
    if (!/^[0-9A-Za-z\-]+$/.test(data)) return; // 🔹 Only allow valid barcode chars

    // 🧩 Prevent duplicate scans within short time (optional)
    // const now = Date.now();
    // if (refLastScanTime.current && now - refLastScanTime.current < 1000) {
    //   // ignore if within 1 sec of last scan
    //   return;
    // }
    // refLastScanTime.current = now;

    refBarcodeVerifySKU.current = data;
    console.log("handleScan data:", data);

    // 🔍 Make a copy before modifying
    const newFormData = [...MerchandiseReceptionProduct];

    const matchIndex = newFormData.findIndex(
      (x) => x.SKU?.toLowerCase() === data.toLowerCase(),
    );
    debugger;
    if (matchIndex >= 0) {
      let merchandiseReceptionProductID =
        newFormData[matchIndex].MerchandiseReceptionProductID;
      // let orderedUnits = newFormData[matchIndex].OrderUnits;
      // let processedUnits = newFormData[matchIndex].OrderProcessedUnits;
      // if (orderedUnits <= processedUnits) {
      //   swalMessage(
      //     <div>
      //       <h2>All units for this product have already been processed.</h2>
      //       <p>
      //         Scanned: <b>{data}</b>
      //       </p>
      //     </div>,
      //   );
      //   return;
      // }

      let currentUserID = currentUser?.Id;
      // TryLockMerchandiseReceptionProduct
      dispatch(
        inventoryHistoryActions.TryLockMerchandiseReceptionProduct({
          merchandiseReceptionProductID,
          currentUserID,
        }),
      ).then((response) => {
        if (
          response?.type ===
          "inventoryHistory/TryLockMerchandiseReceptionProduct/fulfilled"
        ) {
          if (response?.payload) {
            // ✅ Found matching SKU
            const updatedRow = { ...newFormData[matchIndex], IsScanner: true };
            newFormData[matchIndex] = updatedRow;
            setMerchandiseReceptionProduct(newFormData);
            setTimeout(() => {
              const rowElement =
                rowRefs.current[
                  newFormData[matchIndex].MerchandiseReceptionProductID
                ];

              if (rowElement) {
                rowElement.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
              }
            }, 100);
          } else {
            // ❌ Could not lock
            swalMessage(
              <div>
                <h2>Product is already locked by another user</h2>
                <p>
                  Scanned: <b>{data}</b>
                </p>
              </div>,
            );
          }
        }
      });
    } else {
      // ❌ Not matched
      // playBeep('error');
      swalMessage(
        <div>
          <h2>SKU not matched!</h2>
          <p>
            Scanned: <b>{data}</b>
          </p>
        </div>,
      );
    }
  };

  const handleMRProductChange = (index, field, value) => {
    // --- Step 1: Input validation ---
    if (field === "TransactionUnits" || field === "LotNumber") {
      if (value !== "" && !/^[0-9A-Za-z\-]+$/.test(value)) return;
    }

    // --- Step 2: Clone state immutably ---
    const updatedList = [...MerchandiseReceptionProduct];
    const updatedItem = { ...updatedList[index] };
    if (!updatedItem) return; // safety check

    // --- Step 3: Handle field-specific logic ---
    if (field === "TransactionUnits") {
      const newValue = Number(value);
      //const { OrderUnits = 0, OrderProcessedUnits = 0 } = updatedItem;

      //if (OrderUnits >= newValue + OrderProcessedUnits) {
      updatedItem[field] = newValue;
      //} else {
      // Toastr("Transaction units exceed available inventory.", "warning");
      //   return;
      // }
    } else {
      updatedItem[field] = value;
    }

    // --- Step 4: Update state ---
    updatedList[index] = updatedItem;
    setMerchandiseReceptionProduct(updatedList);
  };

  const handleSaveMRProduct = async (index) => {
    const updatedList = [...MerchandiseReceptionProduct];
    const updatedItem = { ...updatedList[index] };
    if (!updatedItem) return; // safety check

    showLoader();

    if (
      !updatedItem.TransactionUnits ||
      !updatedItem.LotNumber ||
      !updatedItem.LotDate ||
      Number(updatedItem.TransactionUnits) <= 0
    ) {
      hideLoader();
      Toastr(
        "Please enter valid Transaction Units, Lot Number, and Lot Date.",
        "warning",
      );
      return; // ✅ stop further execution
    }

    try {
      const params = {
        LotNumber: updatedItem.LotNumber,
        ProductID: updatedItem.ProductID,
        MerchandiseReceptionProductID:
          updatedItem.MerchandiseReceptionProductID,
      };
      const res = await CommonService.LotNumberExistCheckForMRP(params);

      console.log("API Response:", res);

      if (res?.data === 0) {
        hideLoader();
        Toastr(
          "This Lot Number has already been created. Please enter another Lot Number.",
          "warning",
        );
        return;
      }
    } catch (error) {
      hideLoader();
      console.error("Error checking Lot Number:", error);
      Toastr("Error checking Lot Number. Please try again.", "error");
      return;
    }

    dispatch(
      inventoryHistoryActions.UpdateMerchandiseReceptionProduct(updatedItem),
    ).then((response) => {
      if (
        response?.type ===
        "inventoryHistory/UpdateMerchandiseReceptionProduct/fulfilled"
      ) {
        if (response?.payload) {
          if (response?.payload === 1) {
            let CurrentUserID = currentUser?.Id;
            let MerchandiseReceptionID = updatedItem.MerchandiseReceptionID;

            dispatch(
              inventoryHistoryActions.GetMerchandiseReceptionProductByMRID({
                MerchandiseReceptionID,
                Status: 1,
                CurrentUserID,
              }),
            ).then((response) => {
              if (
                response?.type ===
                "inventoryHistory/GetMerchandiseReceptionProductByMRID/fulfilled"
              ) {
                if (response?.payload) {
                  hideLoader();
                  Toastr(
                    "Merchandise Reception Product updated successfully",
                    "success",
                  );
                  setMerchandiseReceptionProduct(
                    response?.payload?.merchandiseReceptionProductModel,
                  );
                  hideLoader();
                } else {
                  Toastr("error", "warning");
                  hideLoader();
                  setMerchandiseReceptionProduct([]);
                }
              } else {
                Toastr("error", "warning");
                hideLoader();
                setMerchandiseReceptionProduct([]);
              }
            });
          } else {
            Toastr("Error updating Merchandise Reception Product", "warning");
            hideLoader();
          }
          //let getInventoryDetailList = response?.payload;
        } else {
          Toastr("Error updating Merchandise Reception Product", "warning");
          hideLoader();
        }
      } else {
        Toastr("Error updating Merchandise Reception Product", "warning");
        hideLoader();
      }
    });
  };

  const handleCancelMRProduct = (index) => {
    const updatedList = [...MerchandiseReceptionProduct];
    const updatedItem = { ...updatedList[index] };
    if (!updatedItem) return; // safety check
    updatedItem.IsScanner = false;
    updatedItem.TransactionUnits = 0;
    updatedItem.IsLocked = false;
    updatedItem.LockedBy = null;

    updatedList[index] = updatedItem;
    setMerchandiseReceptionProduct(updatedList);

    dispatch(
      inventoryHistoryActions.ReleaseLockMerchandiseReceptionProduct({
        merchandiseReceptionProductID:
          updatedItem.MerchandiseReceptionProductID,
      }),
    );
  };

  const handleDeleteMRProduct = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        let CurrentUserID = currentUser?.Id;
        const updatedList = [...MerchandiseReceptionProduct];
        const itemToDelete = updatedList[index];

        showLoader();
        dispatch(
          inventoryHistoryActions.DeleteMerchandiseReceptionProduct({
            MerchandiseReceptionProductID:
              itemToDelete.MerchandiseReceptionProductID,
            CurrentUserID,
          }),
        ).then((response) => {
          if (
            response?.type ===
            "inventoryHistory/DeleteMerchandiseReceptionProduct/fulfilled"
          ) {
            if (response?.payload) {
              if (response?.payload === 1) {
                updatedList.splice(index, 1);
                setMerchandiseReceptionProduct([...updatedList]);
                Toastr(
                  "Merchandise Reception Product deleted successfully",
                  "success",
                );

                hideLoader();
              } else {
                Toastr(
                  "Error deleting Merchandise Reception Product",
                  "warning",
                );
                hideLoader();
              }
            } else {
              Toastr("Error deleting Merchandise Reception Product", "warning");
              hideLoader();
            }
          } else {
            Toastr("Error deleting Merchandise Reception Product", "warning");
            hideLoader();
          }
        });
      }
    });
  };

  const handleMRSubmit = async (event) => {
    if (
      !newFormData.FromWareHouseID ||
      (newFormData.FromWareHouseID && newFormData.FromWareHouseID < 1) ||
      !newFormData.VendorID ||
      (newFormData.VendorID && newFormData.VendorID < 1) ||
      !newFormData.InvoiceNumber
    ) {
      setSubmitted(true);
      Toastr("Please fill in all required fields.", "warning");
      return;
    }

    const allValid = MerchandiseReceptionProduct.some(
      (p) => p.OrderProcessedUnits === 0 || !p.OrderProcessedUnits,
    );

    if (allValid) {
      Toastr(
        "some of the products have zero processed units. Please update before submitting.",
        "warning",
      );
      return;
    }

    let MerchandiseReceptionID = newFormData.ExistingPurchaseOrderOption?.value;
    const MerchandiseReception = {
      MerchandiseReceptionID: MerchandiseReceptionID,
      CreatedBy: currentUser?.Id,
      WareHouseID: newFormData.FromWareHouseID,
      TransactionTypeID: newFormData.TransactionTypeID,
      VendorID: newFormData.VendorID,
      InvoiceNumber: newFormData.InvoiceNumber,
    };

    showLoader();
    if (MerchandiseReceptionProduct.length > 0) {
      let gemar_data = [];
      let PD_data = [];

      // TryLockMerchandiseReception
      let currentUserID = currentUser?.Id;
      const params = {
        MerchandiseReceptionID: MerchandiseReceptionID,
        CurrentUserID: currentUserID,
      };

      const res = await CommonService.TryLockMerchandiseReception(params);
      if (res?.data === true) {
        stopRefresh();
        MerchandiseReceptionProduct.forEach((model) => {
          //  Safely parse numeric fields
          const stockQty = Number(model.StockQuantity) || 0;
          const processedUnits = Number(model.OrderProcessedUnits) || 0;

          // Calculate final inventory
          const FinalInventory = stockQty + processedUnits;

          //  Gemar products
          if (model.IsGemar) {
            gemar_data.push({
              id: Number(model.WCProductID) || 0,
              stock_quantity: FinalInventory,
            });
          }
          //  PartyDeco products
          if (model.IsPartyDeco) {
            PD_data.push({
              id: Number(model.PDWCProductID) || 0,
              stock_quantity: FinalInventory,
            });
          }
        });
        setSubmitted(false);
        if (gemar_data.length > 0 && PD_data.length > 0) {
          AddUpdateOrder_GemarAndPD(gemar_data, PD_data, MerchandiseReception);
        } else if (gemar_data.length > 0) {
          AddUpdateOrder_Gemar(gemar_data, MerchandiseReception);
        } else if (PD_data.length > 0) {
          AddUpdateOrder_PD(PD_data, MerchandiseReception);
        }
      } else {
        hideLoader();
        setAddFormData(initialFormData);
        Toastr(
          "This Merchandise Reception is locked by another user.",
          "warning",
        );
      }
    } else {
      hideLoader();
      Toastr("Please Add Atleast One Product", "warning");
    }
  };

  function bulkInventoryMRPayload(data) {
    dispatch(inventoryHistoryActions.bulkInsertInventoryForMR(data)).then(
      (response) => {
        if (
          response?.type ===
          "inventoryHistory/bulkInsertInventoryForMR/fulfilled"
        ) {
          if (response?.payload === 1) {
            Toastr("Inventory updated successfully", "success");
            hideLoader();
            setAddFormData(initialFormData);
            setMerchandiseReceptionProduct([]);
          } else {
            Toastr("error", "warning");
            hideLoader();
          }
        } else {
          // When not fulfilled (i.e. rejected or error)
          UnlockMerchandiseReception(data.MerchandiseReceptionID);
          Toastr("error", "warning");
          hideLoader();
        }
      },
    );
  }

  function UnlockMerchandiseReception(MerchandiseReceptionID) {
    let params = {
      MerchandiseReceptionID: MerchandiseReceptionID,
    };
    CommonService.UnlockMerchandiseReception(params);
  }

  //#end region Merchandise Reception ------------------  Merchandise Reception End --------------------------------

  return (
    <>
      <PageTitle activeMenu="Bulk Inventory" motherMenu="Inventory" />
      <ToastContainer />
      <BarcodeReader
        minLength={1}
        maxLength={50}
        onError={handleError}
        onScan={handleScan}
      />
      <div className="card">
        <div className="card-header">
          <h4 className="card-title header-title">Transaction History</h4>
        </div>

        <div className="card-body">
          <div className="row">
            <div className="col-md-4 mb-2">
              <label className="text-black font-w700">
                Transaction Type <span className="text-danger">*</span>
              </label>
              <Select
                classNamePrefix="custom_select_css"
                name="TransactionTypeID"
                value={newFormData.TransactionTypeOption || ""} // Selected value
                onChange={(event) =>
                  handleDrpChange(event, "TransactionTypeID")
                }
                options={transactionTypeDrpList} // Dropdown options
                styles={
                  submitted && newFormData.TransactionTypeID === 0 ? styles : {}
                }
              />
            </div>
            {newFormData.TransactionTypeID === 1 && ( // TransactionType => Purchase(1)
              <>
                <div className="col-md-4 mb-2">
                  <label className="text-black font-w700">
                    Purchase Type <span className="text-danger">*</span>
                  </label>
                  <Select
                    classNamePrefix="custom_select_css"
                    name="PurchaseType"
                    value={newFormData.PurchaseTypeOption || ""} // Selected value
                    onChange={(event) => handleDrpChange(event, "PurchaseType")}
                    options={PurchaseTypeOption} // Dropdown options
                  />
                </div>
                {newFormData.PurchaseTypeOption?.value === 2 && ( // PurchaseType => Merchandise Reception(2)
                  <div className="col-md-4 mb-2">
                    <label className="text-black font-w700">
                      Existing Purchase Order{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <Select
                      classNamePrefix="custom_select_css"
                      name="ExistingPurchaseOrderID"
                      value={newFormData.ExistingPurchaseOrderOption || ""} // Selected value
                      onChange={(event) =>
                        handleDrpChange(event, "ExistingPurchaseOrderID")
                      }
                      options={merchandiseReceptionForDropdown} // Dropdown options
                      //styles={submitted && newFormData.TransactionTypeID === 0 ? styles : {}}
                    />
                  </div>
                )}
              </>
            )}

            {/*Warehouse*/}
            <div className="col-md-4 mb-2">
              <label className="text-black font-w700">
                Warehouse<span className="text-danger">*</span>
              </label>
              <Select
                classNamePrefix={"custom_select_css"}
                name="FromWareHouseID"
                value={newFormData.FromWarehouseOption || ""}
                onChange={(event) => handleDrpChange(event, "FromWareHouseID")}
                options={warehouseDrpList}
                styles={
                  submitted && newFormData.FromWareHouseID === 0 ? styles : ""
                }
              />
            </div>

            {/* To Warehouse*/}
            {newFormData.TransactionTypeID === 2 && (
              <div className="col-md-4 mb-2">
                <label className="text-black font-w700">
                  To Warehouse<span className="text-danger">*</span>{" "}
                </label>
                <Select
                  classNamePrefix={"custom_select_css"}
                  name="ToWareHouseID"
                  value={newFormData.ToWarehouseOption || ""}
                  onChange={(event) => handleDrpChange(event, "ToWareHouseID")}
                  options={warehouseDrpList}
                  styles={
                    submitted && newFormData.ToWareHouseID === 0 ? styles : ""
                  }
                />
              </div>
            )}

            {/* Vendor*/}
            {newFormData.TransactionTypeID === 1 && (
              <div className="col-md-4 mb-2">
                <label className="text-black font-w700">
                  Vendor<span className="text-danger">*</span>
                </label>
                <Select
                  classNamePrefix={"custom_select_css"}
                  value={newFormData.VendorOption}
                  name="VendorID"
                  onChange={(event) => handleDrpChange(event, "VendorID")}
                  options={vendorDrpList}
                  styles={submitted && newFormData.VendorID === 0 ? styles : ""}
                />
              </div>
            )}

            {(newFormData.TransactionTypeID === 3 ||
              newFormData.TransactionTypeID === 4) && (
              <div className="col-md-4 mb-2">
                <label className="text-black font-w700">Vendor</label>
                <input
                  type="text"
                  className="form-control readonly_css"
                  value="Gemar"
                  disabled
                />
              </div>
            )}

            {/* Invoice Number*/}
            <div className="col-md-4 mb-2">
              <label className="text-black font-w700">
                Invoice Number
                <span className="text-danger">*</span>
              </label>
              <div className="contact-name">
                <input
                  type="text"
                  className={`form-control ${
                    submitted && !newFormData.InvoiceNumber && "border-danger"
                  }`}
                  autoComplete="off"
                  name="InvoiceNumber"
                  required="required"
                  onChange={handleChange}
                  placeholder={"Invoice Number"}
                  value={newFormData.InvoiceNumber}
                  maxLength={15}
                />
                <span className="validation-text"></span>
              </div>
            </div>

            {newFormData.PurchaseTypeOption?.value !== 2 && ( // PurchaseType => Merchandise Reception(2)
              <>
                {/*Product*/}
                <div className="col-md-4 mb-3">
                  <label className="text-black font-w700">
                    Product<span className="text-danger">*</span>
                  </label>
                  <Select
                    classNamePrefix={"custom_select_css"}
                    name="ProductID"
                    value={newFormData.ProductOption}
                    options={productList}
                    onChange={(event) => handleDrpChange(event, "ProductID")}
                    isDisabled={
                      newFormData.IndexId >= 0 &&
                      newFormData.TypeOrderProductModelList[newFormData.IndexId]
                        .ProductID > 0
                        ? true
                        : false
                    }
                    styles={
                      submitted && !newFormData.ProductOption ? styles : ""
                    }
                  />
                </div>

                {/*Category*/}
                <div className="col-md-4 mb-3">
                  <label className="text-black font-w700">
                    Category<span className="text-danger">*</span>
                  </label>
                  <Select
                    classNamePrefix={"custom_select_css"}
                    name="CategoryID"
                    value={newFormData.CategoryOption}
                    options={categoryDrpList}
                    //onChange={(event) => handleDrpChange(event, "CategoryID")}
                    isDisabled={true}
                    styles={
                      submitted && !newFormData.CategoryOption ? styles : ""
                    }
                  />
                </div>

                <div className="col-md-4 mb-3">
                  <label className="text-black font-w700">
                    Sub Category<span className="text-danger">*</span>
                  </label>
                  <Select
                    classNamePrefix={"custom_select_css"}
                    name="SubCategoryID"
                    value={newFormData.SubCategoryOption}
                    options={subCategoryList}
                    //onChange={(event) => handleDrpChange(event, "SubCategoryID")}
                    isDisabled={true}
                    styles={
                      submitted && !newFormData.SubCategoryOption ? styles : ""
                    }
                  />
                </div>
                {/* Actual Inventory*/}
                <div className="col-md-4 mb-2">
                  <label className="text-black font-w700">
                    Actual Inventory{" "}
                  </label>
                  <div className="contact-name">
                    <input
                      type="text"
                      className={`form-control readonly_css`}
                      autoComplete="off"
                      name="ActualInventory"
                      required="required"
                      placeholder="Actual Inventory"
                      value={newFormData.ActualInventory}
                      disabled
                    />
                    <span className="validation-text"></span>
                  </div>
                </div>

                {/* Transaction Units*/}
                <div className="col-md-4 mb-2">
                  <label className="text-black font-w700">
                    {" "}
                    Transaction Units <span className="text-danger">*</span>
                  </label>
                  <div className="contact-name">
                    <input
                      type="text"
                      className={`form-control ${
                        submitted &&
                        (!addFormData.TransactionUnits ||
                          (addFormData.TransactionUnits &&
                            addFormData.TransactionUnits < 1)) &&
                        "border-danger"
                      }`}
                      autoComplete="off"
                      name="TransactionUnits"
                      required="required"
                      onChange={(e) => handleChange(e)}
                      placeholder="Transaction Units"
                      value={newFormData.TransactionUnits}
                      maxLength={6}
                    />
                    <span className="validation-text"></span>
                  </div>
                </div>

                {/* Final inventory*/}
                <div className="col-md-4 mb-2">
                  <label className="text-black font-w700">
                    {" "}
                    Final inventory
                  </label>
                  <div className="contact-name">
                    <input
                      type="text"
                      className={`form-control readonly_css`}
                      autoComplete="off"
                      name="FinalInventory"
                      required="required"
                      onChange={handleChange}
                      placeholder="Final Inventory"
                      value={newFormData.FinalInventory}
                      disabled
                    />
                    <span className="validation-text"></span>
                  </div>
                </div>

                {/* Lot Number */}
                {newFormData.TransactionTypeID === 1 && (
                  <>
                    <div className="col-md-4 mb-2">
                      <label className="text-black font-w700">
                        Lot Number<span className="text-danger">*</span>
                      </label>
                      <div className="contact-name">
                        <input
                          type="text"
                          className={`form-control ${
                            submitted &&
                            !newFormData.LotNumber &&
                            "border-danger"
                          }`}
                          autoComplete="off"
                          name="LotNumber"
                          required="required"
                          onChange={handleChange}
                          placeholder="Lot Number"
                          value={newFormData.LotNumber}
                          maxLength={50}
                        />
                        <span className="validation-text"></span>
                      </div>
                    </div>
                    {/* Lot Date */}
                    <div className="col-md-4 mb-2">
                      <label className="text-black font-w700">
                        Lot Date<span className="text-danger">*</span>
                      </label>
                      <div
                        className={`date-picker-wrapper ${
                          submitted && !newFormData.LotDate
                            ? "border-danger"
                            : ""
                        }`}
                      >
                        <DatePicker
                          className={`form-control`}
                          name="LotDate"
                          initialDate={newFormData.LotDate}
                          selected={newFormData.LotDate}
                          placeholder="MM/DD/YYYY"
                          showDefaultIcon={true}
                          dateFormat="MM/DD/YYYY" // Set date format here
                          onChange={handleDateChange}
                          style={{ width: "100%", height: "48px" }}
                        />
                      </div>
                      <span className="validation-text"></span>
                    </div>
                  </>
                )}

                {/* Product Image */}
                <div className="row">
                  <div className="col-md-4 mb-2">
                    <label className="text-black font-w700">
                      Product Image
                    </label>
                    <div className="col-md-9 mb-3">
                      {newFormData.ProductImage ? (
                        <img
                          style={{ height: "170px" }}
                          className="card-img-top"
                          src={
                            newFormData.ProductImage && newFormData.ProductImage
                              ? REACT_APP_API_IMAGE_URL +
                                newFormData.ProductImage
                              : ""
                          }
                          alt="Card_image_cap"
                        />
                      ) : (
                        <img
                          style={{ height: "170px" }}
                          className="card-img-top"
                          src={emptyImage}
                          alt="Card_image_cap"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}

            <div className="d-flex justify-content-end align-items-center gap-2">
              {/* File Upload Section */}
              {(currentUser.UserTypeID === 1 ||
                currentUser.UserTypeID === 2 ||
                currentUser.UserTypeID === 5) &&
                newFormData.PurchaseTypeOption?.value === 2 &&
                newFormData.ExistingPurchaseOrderOption?.value === 0 && ( // PurchaseType => Merchandise Reception(2)
                  <div className="d-flex align-items-center gap-2">
                    <label htmlFor="excelFile" className="btn btn-primary mb-2">
                      Upload Excel File
                    </label>
                    <input
                      id="excelFile"
                      type="file"
                      accept=".xlsx, .xls"
                      className="d-none"
                      onChange={(event) => UploadExcelFile(event)}
                    />
                  </div>
                )}

              {/* Add Inventory Button */}
              {(currentUser.UserTypeID === 1 ||
                currentUser.UserTypeID === 2 ||
                currentUser.UserTypeID === 5) &&
                newFormData.PurchaseTypeOption?.value !== 2 && (
                  <Button
                    onClick={handleAddInventory}
                    className="btn btn-primary"
                    disabled={newFormData.TransactionTypeID === 2}
                  >
                    {isEditMode ? "Update Inventory" : "Add Inventory"}
                  </Button>
                )}
            </div>
          </div>

          {/*Direct Inventory Dynamic Table Start*/}
          {newFormData.PurchaseTypeOption?.value !== 2 && (
            <div className="table-responsive">
              <div id="job_data" className="dataTables_wrapper">
                <table
                  className="display w-100 dataTable "
                  id="example5"
                  role="grid"
                  aria-describedby="example5_info"
                >
                  <thead>
                    <tr role="row">
                      <th className="sorting_asc" style={{ width: "177px" }}>
                        {" "}
                        Product Name
                      </th>
                      <th className="sorting_asc" style={{ width: "177px" }}>
                        {" "}
                        Transaction Type
                      </th>
                      <th className="sorting" style={{ width: "200px" }}>
                        Warehouse
                      </th>
                      <th className="sorting" style={{ width: "200px" }}>
                        {" "}
                        Invoice Number
                      </th>
                      <th className="sorting" style={{ width: "200px" }}>
                        {" "}
                        Actual Inventory
                      </th>
                      <th className="sorting" style={{ width: "200px" }}>
                        {" "}
                        Transaction Units
                      </th>
                      <th className="sorting" style={{ width: "200px" }}>
                        {" "}
                        Final inventory
                      </th>
                      <th className="sorting" style={{ width: "200px" }}>
                        {" "}
                        Lot Number
                      </th>
                      <th className="sorting" style={{ width: "200px" }}>
                        Lot Date
                      </th>
                      <th className="sorting" style={{ width: "200px" }}>
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {BulkInventory.length > 0 &&
                      BulkInventory.map((addFormData, index) => {
                        return (
                          <tr key={index}>
                            <td>{addFormData.ProductOption?.label}</td>
                            <td>{addFormData.TransactionTypeOption?.label}</td>
                            <td>{addFormData.FromWarehouseOption?.label}</td>
                            <td>{addFormData.InvoiceNumber}</td>
                            <td>{addFormData.ActualInventory}</td>
                            <td>{addFormData.TransactionUnits}</td>
                            <td>{addFormData.FinalInventory}</td>
                            <td>{addFormData.LotNumber}</td>
                            <td>
                              {addFormData?.TransactionTypeID === 3 ||
                              addFormData?.TransactionTypeID === 4
                                ? ""
                                : addFormData?.LotDate
                                  ? new Date(
                                      addFormData.LotDate,
                                    ).toLocaleDateString()
                                  : new Date().toLocaleDateString()}
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                <button
                                  className="btn btn-primary shadow btn-xs sharp me-1"
                                  onClick={() => handleEditInventory(index)}
                                >
                                  <i className="fas fa-pen"></i>
                                </button>

                                <button
                                  className="btn btn-danger shadow btn-xs sharp"
                                  onClick={() => handleDeleteInventory(index)}
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    {BulkInventory.length === 0 && (
                      <tr>
                        <td colSpan="9" align="center">
                          No inventory added yet.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {/* Direct Inventory Dynamic Table END*/}

          {/*Merchandise Reception Dynamic Table Start*/}
          {newFormData.PurchaseTypeOption?.value === 2 && ( // PurchaseType => Merchandise Reception(2)}
            <div className="table-responsive">
              <div
                id="MerchandiseReception_data"
                className="dataTables_wrapper"
              >
                <table
                  className="display w-100 dataTable "
                  id="MerchandiseReception"
                  role="grid"
                  aria-describedby="example5_info"
                >
                  <thead>
                    <tr role="row">
                      <th className="sorting_asc" style={{ width: "177px" }}>
                        {" "}
                        Product Name
                      </th>
                      <th className="sorting_asc" style={{ width: "177px" }}>
                        {" "}
                        SKU
                      </th>
                      <th className="sorting_asc" style={{ width: "177px" }}>
                        {" "}
                        Location
                      </th>
                      <th className="sorting" style={{ width: "200px" }}>
                        {" "}
                        Actual Inventory
                      </th>
                      <th className="sorting" style={{ width: "200px" }}>
                        {" "}
                        Order Units
                      </th>
                      <th className="sorting" style={{ width: "200px" }}>
                        {" "}
                        Order Processed Units
                      </th>
                      <th className="sorting" style={{ width: "200px" }}>
                        {" "}
                        Transaction Units
                      </th>
                      <th className="sorting" style={{ width: "200px" }}>
                        {" "}
                        Units Per Box
                      </th>

                      <th className="sorting" style={{ width: "200px" }}>
                        {" "}
                        Lot Number
                      </th>
                      <th className="sorting" style={{ width: "200px" }}>
                        Lot Date
                      </th>
                      <th className="sorting" style={{ width: "200px" }}>
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {MerchandiseReceptionProduct.length > 0 &&
                      MerchandiseReceptionProduct.map((addFormData, index) => {
                        const isEditMode = addFormData.IsScanner === true; // true → editable mode
                        return (
                          <tr
                            key={index}
                            ref={(el) => {
                              if (el) {
                                rowRefs.current[
                                  addFormData.MerchandiseReceptionProductID
                                ] = el;
                              }
                            }}
                          >
                            <td>{addFormData.ProductName}</td>

                            {/* SKU Field */}
                            <td>
                              <a
                                className={`badge-rounded ${
                                  isEditMode === true &&
                                  "barcode-outline-verify"
                                }`}
                              >
                                {addFormData.SKU}
                              </a>
                            </td>
                            <td>{addFormData.Location}</td>
                            <td>{addFormData.StockQuantity}</td>
                            <td>{addFormData.OrderUnits}</td>
                            <td>{addFormData.OrderProcessedUnits}</td>

                            {/* Transaction Units */}
                            <td>
                              {isEditMode ? (
                                <input
                                  type="text"
                                  name="TransactionUnits"
                                  value={addFormData.TransactionUnits || ""}
                                  onChange={(e) =>
                                    handleMRProductChange(
                                      index,
                                      "TransactionUnits",
                                      e.target.value,
                                    )
                                  }
                                  className="form-control form-control-sm"
                                />
                              ) : (
                                addFormData.TransactionUnits
                              )}
                            </td>
                            {/* UnitsPerBox */}
                            <td>{addFormData.UnitsPerBox}</td>
                            {/* Lot Number */}
                            <td>
                              {isEditMode ? (
                                <input
                                  type="text"
                                  name="LotNumber"
                                  maxLength={50}
                                  value={addFormData.LotNumber || ""}
                                  onChange={(e) =>
                                    handleMRProductChange(
                                      index,
                                      "LotNumber",
                                      e.target.value,
                                    )
                                  }
                                  className="form-control form-control-sm"
                                />
                              ) : (
                                addFormData.LotNumber
                              )}
                            </td>

                            {/* Lot Date */}
                            <td>
                              {isEditMode ? (
                                <input
                                  type="date"
                                  name="LotDate"
                                  value={
                                    addFormData.LotDate
                                      ? format(
                                          new Date(addFormData.LotDate),
                                          "yyyy-MM-dd",
                                        )
                                      : ""
                                  }
                                  onChange={(e) =>
                                    handleMRProductChange(
                                      index,
                                      "LotDate",
                                      e.target.value,
                                    )
                                  }
                                  className="form-control form-control-sm"
                                />
                              ) : (
                                <span>
                                  {addFormData.LotDate
                                    ? format(
                                        new Date(addFormData.LotDate),
                                        "MM/dd/yyyy",
                                      )
                                    : ""}
                                </span>
                              )}
                            </td>

                            {/* Actions */}
                            <td className="align-middle">
                              <div className="d-flex align-items-center justify-content-center">
                                {isEditMode ? (
                                  <>
                                    <button
                                      className="btn btn-success MREditCss shadow btn-xs sharp me-1"
                                      title="Save"
                                      onClick={() => handleSaveMRProduct(index)}
                                    >
                                      <i className="fa fa-save"></i>
                                    </button>
                                    <button
                                      className="btn shadow MRCancelCss btn-xs sharp me-1"
                                      title="Cancel"
                                      onClick={() =>
                                        handleCancelMRProduct(index)
                                      }
                                    >
                                      <i className="fa fa-times"></i>
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    {/* 🔒 Locked by another user → show grey lock icon */}
                                    {addFormData.IsLocked === true &&
                                    addFormData.LockedBy !== currentUser?.Id ? (
                                      <span
                                        title={`Locked by ${addFormData.LockedByName}`}
                                        style={{
                                          fontSize: "22px",
                                          cursor: "not-allowed",
                                          color: "grey", // ✔ Grey lock
                                        }}
                                      >
                                        <i className="fa fa-lock"></i>
                                      </span>
                                    ) : (
                                      /* 🔓 Not locked or locked by current user → show delete button */
                                      <button
                                        className="btn btn-danger shadow btn-xs sharp"
                                        title="Delete"
                                        onClick={() =>
                                          handleDeleteMRProduct(index)
                                        }
                                      >
                                        <i className="fa fa-trash"></i>
                                      </button>
                                    )}
                                  </>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}

                    {MerchandiseReceptionProduct.length === 0 && (
                      <tr>
                        <td colSpan="9" align="center">
                          No inventory added yet.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {/* Merchandise Reception Dynamic Table END*/}
          {(currentUser.UserTypeID === 1 ||
            currentUser.UserTypeID === 5 ||
            currentUser.UserTypeID === 2) && (
            <div className="card-body">
              <div className="row">
                <div className="col-12">
                  <button
                    type="button"
                    onClick={(event) =>
                      newFormData.PurchaseTypeOption?.value === 2 &&
                      newFormData.TransactionTypeID === 1
                        ? handleMRSubmit(event)
                        : handleSubmit(event, true)
                    }
                    style={{ float: "right" }}
                    className="btn btn-primary mb-2"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          )}

          {loader}
        </div>
      </div>
    </>
  );
};
export default BulkInventory;
